<template>
  <a target="_blank" :href="link" class="leaving absolute">
    <div class="leaving-content center mx-auto p4 h5">
      Click to view this <strong>FA-supported project</strong> in a new tab<br />
      <a
        :href="link"
        target="_blank"
        class="inline-block mt1 py1 px2 mono h5"
        >{{ link }}</a
      >
    </div>
  </a>
</template>

<script>
export default {
  data() {
    return {
      seconds: 9,
      interval: null,
    };
  },
  props: ["link", "title"],
  mounted() {
    // this.interval = setInterval(this.updateSecs, 1000)
  },
  methods: {
    updateSecs() {
      if (this.seconds > 1) {
        this.seconds = this.seconds - 1;
      } else {
        document.location.href = this.$props.link;
        this.$emit("close");
      }
    },
  },
  beforeDestroy() {
    // clearInterval(this.interval)
  },
};
</script>

<style lang="css" scoped>
.leaving {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  color: var(--red);
  padding: 2em;
  display: none;
  background: var(--col-light);
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-out;
  display: flex;

  .leaving-content {
    width: 100%;
  }

  a {
    border-radius: 3px;
    max-width: 85%;
    cursor: pointer;
    color: var(--red);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    pointer-events: all;
    background: rgba(238, 66, 56, 0.15);
  }
}

@media (max-width: 1024px) {
  .leaving {
    display: none !important;
  }
}
</style>
